/**
 * @constant epstIndications
 * @description
 * Contiene las indicaciones generales que deben conocer los candidatos antes de iniciar
 * la certificación EPST (English Proficiency Standard Test).
 *
 * Proporciona tiempos estimados de duración para niños y adultos, y un listado de advertencias
 * e instrucciones clave para completar el examen de forma correcta.
 *
 * @property {string} estimatedTimeKids - Tiempo estimado de duración del examen para niños.
 * @property {string} estimatedTimeAdults - Tiempo estimado de duración del examen para adultos.
 * @property {Array<Object>} indications - Lista de indicaciones a mostrar antes de iniciar el examen.
 * @property {string} indications[].icon - Icono representativo para la indicación.
 * @property {string} indications[].color - Color del badge asociado al ícono.
 * @property {string} indications[].title - Título de la indicación.
 * @property {string} indications[].description - Descripción detallada de la indicación.
 */
export const epstIndications = {
	estimatedTimeKids: "1 hora y 40 minutos",
	estimatedTimeAdults: "2 horas y 19 minutos",
	indications: [
		{
			icon: 'timer',
			color: 'success',
			title: 'Tiempo estimado',
			description: `El tiempo estimado para terminar esta certificación es:  minutos.`
		},
		{
			icon: 'distractions',
			color: 'primary',
			title: 'Distracciones',
			description: 'Evita tener distracciones. Si durante los siguientes minutos tienes algún compromiso, evita iniciar esta certificación hasta contar con el tiempo necesario.'
		},
		{
			icon: 'engine',
			color: 'primary',
			title: 'Configuraciones',
			description: 'Esta certificación cuenta con preguntas que requieren respuestas grabadas en audio, por lo tanto, recuerda preparar tu micrófono para poder grabar tus respuestas.'
		},
		{
			icon: 'speaker',
			color: 'primary',
			title: 'Configuraciones',
			description: 'Antes de comenzar tu examen es necesario que revises que tus audífonos o bocinas están funcionando correctamente para que puedas responder la sección de listening sin problema.'
		},
		{
			icon: 'play',
			color: 'primary',
			title: 'Submit',
			description: 'Ten en cuenta que al dar click a submit pasarás a la siguiente pregunta y ya no podrás regresar a las preguntas anteriores.'
		},
		{
			icon: 'lostConnection',
			color: 'primary',
			title: 'Conexión',
			description: 'En caso de que cierres la pestaña o pierdas la conexión de internet perderás tu examen, es necesario comunicarte con tu profesor y al área de operaciones de CertifiED.'
		},
		{
			icon: 'timer',
			color: 'primary',
			title: 'Tiempo por pregunta',
			description: 'En la parte superior podrás ver cuánto tiempo tienes para responder cada pregunta.'
		}
	]
};